<template>
  <SnackbarMultiple
    ref="snackbar"
    top
    right
    dark
    :max-items="10"
    :delay="500"
    :timeout="10000"
  />
</template>

<script>
import SnackbarMultiple from '@/modules/_global/_components/SnackbarMultiple';

export default {
  name: 'Snacks',

  components: {
    SnackbarMultiple
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  watch: {
    items: {
      handler(e) {
        this.setSnacks(e);
      },
      deep: true
    }
  },

  methods: {
    setSnacks(items) {
      if (items.length) {
        items.forEach(item => {
          this.$refs.snackbar.addItem(item);
        });

        this.$emit('clearSnacks');
      }
    }
  }
};
</script>

<style scoped></style>
